import useFirebase from './useFirebase';

export default function useFirestore() {
  const firebase = useFirebase();
  return firebase.firestore;
}
